import React, { PropTypes } from 'react';
import ReactDOM from 'react-dom';
import { message } from 'antd';

import AjaxBase from './AjaxBase';
import GlobalSharedTools from './GlobalSharedTools';
import EXIF from './exif';

message.config({
  top: 300,
  duration: 2,
});

// consts
const UPLOAD_FILE_CATEGORIES = {
  IMAGES: 'IMAGES',
  VIDEOS: 'VIDEOS',
  AUDIOS: 'AUDIOS',
  TEXT: 'TEXT',
  OFFICE_DOCS: 'OFFICE_DOCS',
  ALL: null
};
const FILE_CATEGORIES_MAP = {
  IMAGES: ['image'],
  VIDEOS: ['video'],
  AUDIOS: ['audio'],
  TEXT: ['text'],
  OFFICE_DOCS: ['vnd.ms-excel', 'vnd.ms-powerpoint', 'vnd.ms-word'],
  _BLACK_LIST: ['application/vnd.microsoft.portable-executable', 'application/octet-stream']
};

// 图片上传前压缩后的 JPEG 质量（与小程序端 compressImageUnified 的 quality 80 一致）
const JPEG_QUALITY = 0.8;

// component
export default class ReactQiniuModule extends React.Component {
    // static functions
    static get getFileCategories() {
      return UPLOAD_FILE_CATEGORIES;
    }

    constructor(props, context) {
      super(props, context);
      // set state
      this.state = {
        isDragActive: false,
      };
      // bind this
      this.getUrl = this.getUrl.bind(this);
      this.checkFileType = this.checkFileType.bind(this);
      this.isFileTypeWithin = this.isFileTypeWithin.bind(this);
      this.checkFileSize = this.checkFileSize.bind(this);
      this.getFileAdditionalInfo = this.getFileAdditionalInfo.bind(this);

      this.onDragLeave = this.onDragLeave.bind(this);
      this.onDragOver = this.onDragOver.bind(this);
      this.onDrop = this.onDrop.bind(this);
      this.onClick = this.onClick.bind(this);
      this.open = this.open.bind(this);
      this.getUploadToken = this.getUploadToken.bind(this);
      this.upload = this.upload.bind(this);
      this.uploadFromQueue = this.uploadFromQueue.bind(this);
      this.ajaxUpload = this.ajaxUpload.bind(this);
    }

    componentWillMount() {
      this.isStartedFetchFileFromQueue = false;
    }

    componentDidMount() {
      this.uploadToken = null;
      this.CDN_DOMAIN = "http://qiniu-archive.assets.ddycj.com/";
    }

    // tools
    getUrl(fileKey) {
      return this.CDN_DOMAIN + fileKey;
    }

    checkFileType(fileType) {
      let validated = false;
      if (this.props.allowUploadFileTypes === undefined || this.props.allowUploadFileTypes === null) {    // no limitation, check black list
        validated = true;
        FILE_CATEGORIES_MAP._BLACK_LIST.forEach((wrongFileType) => {
          if (fileType.indexOf(wrongFileType) >= 0)
            validated = false;
        });

        return {validated: validated, message: (validated ? undefined : "文件不能为可执行文件")};
      }
      else {
        FILE_CATEGORIES_MAP[this.props.allowUploadFileTypes].forEach((correctFileType) => {
          if (fileType.indexOf(correctFileType) >= 0)
            validated = true;
        });

        let message = undefined;
        if (!validated) {
          switch (this.props.allowUploadFileTypes) {
            case UPLOAD_FILE_CATEGORIES.IMAGES:
              message = "上传文件只能为图片类型";
              break;
            case UPLOAD_FILE_CATEGORIES.VIDEOS:
              message = "上传文件只能为视频类型";
              break;
            case UPLOAD_FILE_CATEGORIES.AUDIOS:
              message = "上传文件只能为音频类型";
              break;
            case UPLOAD_FILE_CATEGORIES.TEXT:
              message = "上传文件只能为纯文字类型";
              break;
            case UPLOAD_FILE_CATEGORIES.OFFICE_DOCS:
              message = "上传文件只能为office文件类型";
              break;
          }
        }
        return {validated: validated, message: message};
      }
    }

    isFileTypeWithin(fileType, types) {
      let validated = false;
      for (let i = 0; i < types.length; ++i) {
        let typeName = types[i];
        FILE_CATEGORIES_MAP[typeName].forEach((correctFileType) => {
          if (fileType.indexOf(correctFileType) >= 0)
            validated = true;
        });
      }
      return validated;
    }

    checkFileSize(fileSize) {
      if (this.props.allowUploadFileSize !== undefined && this.props.allowUploadFileSize !== null && this.props.allowUploadFileSize > 0) {
        if (fileSize > this.props.allowUploadFileSize * 1024 * 1024)
          return {validated: false, message: "上传文件的大小不能超过 " + this.props.allowUploadFileSize + "Mb"};
      }
      return {validated: true, message: undefined};
    }

    getFileAdditionalInfo(fileType, file) {
      let _URL = window.URL || window.webkitURL;
      if (this.isFileTypeWithin(fileType, [UPLOAD_FILE_CATEGORIES.IMAGES])) {
        return (new Promise((resolve, reject) => {
          let img = new Image();
          img.onload = function () {
            resolve({w: this.width, h: this.height});
          };
          img.src = _URL.createObjectURL(file);
        }));
      }
      else if (this.isFileTypeWithin(fileType, [UPLOAD_FILE_CATEGORIES.VIDEOS])) {
        return (new Promise((resolve, reject) => {
          let video = document.createElement('video');
          video.preload = 'metadata';
          video.onloadedmetadata = function() {
            _URL.revokeObjectURL(this.src)
            resolve({length: parseInt(video.duration), w: video.videoWidth , h: video.videoHeight})
          }
          video.src = _URL.createObjectURL(file);
        }));
      }
      else if (this.isFileTypeWithin(fileType, [UPLOAD_FILE_CATEGORIES.AUDIOS])) {
        return (new Promise((resolve, reject) => {
          let audio = document.createElement('audio');
          audio.preload = 'metadata';
          audio.onloadedmetadata = function() {
            _URL.revokeObjectURL(this.src)
            resolve({length: parseInt(audio.duration)})
          }
          audio.src = _URL.createObjectURL(file);
        }));
      }
    }

    _imageDownsize(sourceImage, imageOrientation) {
      var MAX_WIDTH = 1600;
      var MAX_HEIGHT = 1600;
      var MIN_SIZE = 500;
      // downsize
      var width = sourceImage.width;
      var height = sourceImage.height;

      if (width > MIN_SIZE && height > MIN_SIZE) {
        if (width > height) {
          if (width > MAX_WIDTH) {
            var compress_height = height * MAX_WIDTH / width;
            if (compress_height < MIN_SIZE) {
              width = MIN_SIZE / height * width;
              height = MIN_SIZE;
            } else {
              height = compress_height;
              width = MAX_WIDTH;
            }
          }
        } else {
          if (height > MAX_HEIGHT) {
            var compress_width = width * MAX_HEIGHT / height;
            if (compress_width < MIN_SIZE) {
              height = MIN_SIZE / width * height;
              width = MIN_SIZE;
            } else {
              width = compress_width;
              height = MAX_HEIGHT;
            }
          }
        }
      }

      // draw new image
      var canvas = document.createElement("canvas");
      var ctx = canvas.getContext("2d");
      canvas.width = width;
      canvas.height = height;
      switch(imageOrientation){
        case 2:
          // horizontal flip
          ctx.translate(canvas.width, 0);
          ctx.scale(-1, 1);
          break;
        case 3:
          // 180° rotate left
          ctx.translate(canvas.width, canvas.height);
          ctx.rotate(Math.PI);
          break;
        case 4:
          // vertical flip
          ctx.translate(0, canvas.height);
          ctx.scale(1, -1);
          break;
        case 5:
          // vertical flip + 90 rotate right
          canvas.width = height;
          canvas.height = width;
          ctx.rotate(0.5 * Math.PI);
          ctx.scale(1, -1);
          break;
        case 6:
          // 90° rotate right
          canvas.width = height;
          canvas.height = width;
          ctx.rotate(0.5 * Math.PI);
          ctx.translate(0, -height);
          break;
        case 7:
          // horizontal flip + 90 rotate right
          canvas.width = height;
          canvas.height = width;
          ctx.rotate(0.5 * Math.PI);
          ctx.translate(width, -height);
          ctx.scale(-1, 1);
          break;
        case 8:
          // 90° rotate left
          canvas.width = height;
          canvas.height = width;
          ctx.rotate(-0.5 * Math.PI);
          ctx.translate(-width, 0);
          break;
      }
      // JPEG 不支持透明通道，先铺白底，避免透明区域变黑（用恒等变换保证铺满整个画布）
      ctx.save();
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.restore();
      ctx.drawImage(sourceImage, 0, 0, width, height);
      // export to file object (JPEG, 质量 0.8，与小程序端保持一致)
      var dataURI = canvas.toDataURL('image/jpeg', JPEG_QUALITY);
      var byteString;
      if (dataURI.split(',')[0].indexOf('base64') >= 0)
        byteString = atob(dataURI.split(',')[1]);
      else
        byteString = unescape(dataURI.split(',')[1]);
      // -- separate out the mime component
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
      // -- write the bytes of the string to a typed array
      var ia = new Uint8Array(byteString.length);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      return new Blob([ia], {type:mimeString});
    }

    // events
    onDragLeave(e) {
      this.setState({
        isDragActive: false
      });
    }

    onDragOver(e) {
      e.preventDefault();
      e.dataTransfer.dropEffect = 'copy';

      this.setState({
        isDragActive: true
      });
    }

    onDrop(e) {
      e.preventDefault();

      this.setState({
        isDragActive: false
      });

      let reg = new RegExp("[\\u4E00-\\u9FFF]+", "g");

      var files;
      if (e.dataTransfer) {
        files = e.dataTransfer.files;
      } else if (e.target) {
        files = e.target.files;
      }

      var maxFiles = (this.props.multiple) ? Math.min(files.length, this.props.getUploadQuota()) : 1;

      if (this.props.onUpload) {
        files = Array.prototype.slice.call(files, 0, maxFiles);
        this.props.onUpload(files, e);
      }

      for (var i = 0; i < maxFiles; i++) {
        if (reg.test(files[i].name)) {
          var newFile = new File([files[i]], new Date().getTime() + '.' + (files[i].name.split('.') ? files[i].name.split('.')[1] : ''), { type: files[i].type});
          newFile.preview = URL.createObjectURL(newFile);
          files[i].request = this.upload(newFile);
        } else {
          files[i].preview = URL.createObjectURL(files[i]);
          files[i].request = this.upload(files[i]);
        }
        
       
        // files[i].uploadPromise = files[i].request.promise();
        
      }

      if (this.props.onDrop) {
        files = Array.prototype.slice.call(files, 0, maxFiles);
        this.props.onDrop(files, e);
      }
    }

    onClick() {
      if (this.props.supportClick) {
        this.open();
      }
    }

    open() {
      var fileInput = ReactDOM.findDOMNode(this.refs.fileInput);
      fileInput.value = null;
      fileInput.click();
    }

    getUploadToken() {
      return (new Promise((resolve, reject) => {
        if (this.uploadToken)
          resolve(this);
        else {
          // get token
          AjaxBase.get(AjaxBase.URL_PREFIX + "files/uptoken").then((response) => {
            this.uploadToken = response.uptoken;
            resolve(this);
          }, (error) => {
            reject(error);
          }).catch((error) => {
            reject(error);
          });
        }
      }));
    }

    ajaxUpload(requestData, file, fileType, errorKey, queue) {
      AjaxBase.uploadFile(this.props.uploadUrl, requestData, null, true, true, file, "file").then((response) => {
        // save file
        if (!this.isFileTypeWithin(fileType, [UPLOAD_FILE_CATEGORIES.IMAGES, UPLOAD_FILE_CATEGORIES.VIDEOS]))
          this.props.onSuccess(response.key, file.name, file.size, this.getUrl(response.key), errorKey);
        else
          this.getFileAdditionalInfo(fileType, file).then((fileAdditionalInfo) => {
            this.props.onSuccess(response.key, file.name, file.size, this.getUrl(response.key), fileAdditionalInfo, errorKey);
          }, (error) => {});
        // next file
        if(queue){
          if (this.props.isPreuploadQueueEmpty()) {       // finish
            this.uploadToken = null;    // next patch upload should get upToken again
            this.isStartedFetchFileFromQueue = false;
          }
          else                                            // continue to fetch file from queue
            this.uploadFromQueue();
        }else {
          if (this.props.isAllFinish()) {
            this.uploadToken = null;    // next patch upload should get upToken again
          }
        }
      }, (error) => {
        console.log("upload file failed", error);
        if (this.props.onError && (GlobalSharedTools.isFunction(this.props.onError))) {
          this.props.onError(requestData.key, file, errorKey);
        }
        if(queue){
          // next file
          if (this.props.isPreuploadQueueEmpty()) {       // finish
            this.uploadToken = null;    // next patch upload should get upToken again
            this.isStartedFetchFileFromQueue = false;
          }
          else                                            // continue to fetch file from queue
            this.uploadFromQueue();
        }
      }).catch((error) => {
        console.log(error);
      });
    }

    upload(file, errorKey) {
      let fileType = file.type.toLowerCase();

      if (!file || file.size === 0) {
        return null
      } else {
        let checkResult = this.checkFileType(fileType);
        if (!checkResult.validated) {
          message.info(checkResult.message);
          return null;
        }
        checkResult = this.checkFileSize(file.size);
        if (!checkResult.validated) {
          message.info(checkResult.message);
          return null;
        }
      }
      // get key (remote file name)
      // 图片会在上传前被重新编码为 JPEG，文件名后缀同步改为 .jpg，避免内容与后缀不一致
      let keyFileName = file.name;
      if (fileType.indexOf("image") >= 0 && this.props.needDownsize)
        keyFileName = keyFileName.replace(/\.[^.\/]*$/, '') + '.jpg';
      let key = Date.now() + "_" + file.preview.split('/').pop() + '/' + keyFileName;
      if (this.props.uploadKey){
        key = this.props.uploadKey;
      }
      if (this.props.uploadKeyPrefix)
        key = this.props.uploadKeyPrefix + key;
      else
        key = "uploads/" + key;

      if (!this.props.isQueueForUpload)         // upload mutiple file at the same time
        this.getUploadToken().then(() => {
          if (this.props.onStartPermit(key)) {
            if(fileType.indexOf("image") >= 0 && this.props.needDownsize){
              var fileReader = new FileReader();
              var imageOrientation = 1;
              var downsizedFile;
              fileReader.onload = function(e){
                var img = document.createElement("img");
                img.onload = function(){
                  downsizedFile = this._imageDownsize(img, imageOrientation);
                  downsizedFile.name = file.name
                  downsizedFile.preview = file.preview
                  let requestData = {
                      key: key,
                      token: this.uploadToken,
                      accept: "application/json"
                    };
                  this.ajaxUpload(requestData, downsizedFile, fileType, errorKey, false)
                }.bind(this);
                img.src = e.target.result;
              }.bind(this);

              EXIF.getData(file, function () {
                imageOrientation = this.exifdata.Orientation;
                fileReader.readAsDataURL(file);
              });
            }else {
              let requestData = {
                  key: key,
                  token: this.uploadToken,
                  accept: "application/json"
                };
              this.ajaxUpload(requestData, file, fileType, errorKey, false)
            }
          }
        }, (error) => {
          console.log("get uptoken failed", key);
          if (this.props.onError && (GlobalSharedTools.isFunction(this.props.onError))) {
            this.props.onError(key, file, errorKey);
          }
        });
      else {                                  // upload files one by one
        this.props.pushFileToPreuploadQueue({file: file, key: key, errorKey: errorKey});
        if (!this.isStartedFetchFileFromQueue) {
          this.isStartedFetchFileFromQueue = true;
          this.uploadFromQueue();
        }
      }
    }

    uploadFromQueue() {
      let object = this.props.popFileFromQueue();
      console.log(object)

      if (object === undefined) {
        this.isStartedFetchFileFromQueue = false;
        return;
      }

      let {file, key, errorKey} = object;
      let fileType = file.type.toLowerCase();
      this.getUploadToken().then(() => {
        if (this.props.onStartPermit(key)) {
          if(fileType.indexOf("image") >= 0 && this.props.needDownsize){
            var fileReader = new FileReader();
            var imageOrientation = 1;
            var downsizedFile;
            fileReader.onload = function(e){
              var img = document.createElement("img");
              img.onload = function(){
                downsizedFile = this._imageDownsize(img, imageOrientation);
                downsizedFile.name = file.name
                downsizedFile.preview = file.preview
                let requestData = {
                    key: key,
                    token: this.uploadToken,
                    accept: "application/json"
                  };
                this.ajaxUpload(requestData, downsizedFile, fileType, errorKey, true)
              }.bind(this);
              img.src = e.target.result;
            }.bind(this);

            EXIF.getData(file, function () {
              imageOrientation = this.exifdata.Orientation;
              fileReader.readAsDataURL(file);
            });
          }else {
            let requestData = {
                key: key,
                token: this.uploadToken,
                accept: "application/json"
              };
            this.ajaxUpload(requestData, file, fileType, errorKey, true)
          }
        }
      }, (error) => {
        console.log("get uptoken failed", key);
        if (this.props.onError && (GlobalSharedTools.isFunction(this.props.onError))) {
          this.props.onError(key, file, errorKey);
        }
        // next file
        if (this.props.isPreuploadQueueEmpty()) {       // finish
          this.uploadToken = null;    // next patch upload should get upToken again
          this.isStartedFetchFileFromQueue = false;
        }
        else                                            // continue to fetch file from queue
          this.uploadFromQueue();
      });
    }

    render() {
      let className = this.props.className || 'dropzone';
      if (this.state.isDragActive) {
        className += ' active';
      }

      return (
        <div className={className} onClick={this.onClick} onDragLeave={this.onDragLeave} onDragOver={this.onDragOver} onDrop={this.onDrop}>
          <input style={{display: 'none'}} type="file" multiple={this.props.multiple} ref='fileInput' onChange={this.onDrop} accept={this.props.accept} />
          {this.props.children}
        </div>
      );
    }
}

ReactQiniuModule.propTypes = {
  supportClick: PropTypes.bool.isRequired,
  multiple: PropTypes.bool.isRequired,
  uploadUrl: PropTypes.string.isRequired,
  uploadKey: PropTypes.string,        // manualy set upload key, default key is file name + timestamp
  uploadKeyPrefix: PropTypes.string,  // prefix for the upload key. final key in the url will be: prefix + customized key or prefix + default key

  className: PropTypes.string,
  onSuccess: PropTypes.func,
  onError: PropTypes.func,
  onStartPermit: PropTypes.func,
  isAllFinish: PropTypes.func,
  getUploadQuota: PropTypes.func,

  allowUploadFileTypes: PropTypes.string,     // get available file types list: ReactQiniuModule.getFileCategories
  allowUploadFileSize: PropTypes.number,      // get file size limit, in term of Mb. undefined/null/-1/0 means no limitation
  needDownsize: PropTypes.bool,

  /* Queueing Mode: upload file one by one */
  isQueueForUpload: PropTypes.bool.isRequired,  // when it is true, mode of 'uploading in queue' is activated
  pushFileToPreuploadQueue: PropTypes.func,     // add new file to the queue
  popFileFromQueue: PropTypes.func,             // pop a file from queue and start to upload it (put it in the uploading-list)
  isPreuploadQueueEmpty: PropTypes.func         // check whether the queue is empty. If it is not, then continue to pop a new file from queue to upload
}
ReactQiniuModule.defaultProps = {
  supportClick: true,
  multiple: true,
  uploadUrl: window.location.protocol === 'https:' ? 'https://up.qbox.me/' : 'http://upload.qiniu.com',

  allowUploadFileTypes: UPLOAD_FILE_CATEGORIES.ALL,
  allowUploadFileSize: 10,

  isQueueForUpload: false,
  needDownsize: true,
}


// WEBPACK FOOTER //
// ./app/javascript/lib/ReactQiniuModule.jsx